import { render, staticRenderFns } from "./CreateCourierServicePopUp.vue?vue&type=template&id=7e089a9c&scoped=true&"
import script from "./CreateCourierServicePopUp.vue?vue&type=script&lang=js&"
export * from "./CreateCourierServicePopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateCourierServicePopUp.vue?vue&type=style&index=0&id=7e089a9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e089a9c",
  null
  
)

export default component.exports